module.exports = __webpack_public_path__ + "static/media/en.da08e077.svg";